import moment from 'moment-timezone';
import { DATE_FORMAT } from '@constants/dates';

// The period pickers hand back either a DATE_FORMAT string or a moment, depending on which tab was used.
const parsePeriodDate = (value) => {
  if (!value) return null;
  if (moment.isMoment(value)) return value.clone();
  return moment(value, [DATE_FORMAT, moment.ISO_8601]);
};

/**
 * A trend compares the reported period against the equally long period before it, so it can only be rendered
 * when that earlier period is still within the rig's data.
 *
 * The fixed periods are resolved and validated by the report scheduler, so they are never gated here.
 *
 * A rig with no lower limit is not gated either: there is nothing to measure against, 
 * and the scheduler keeps the trend in that case too.
 *
 * lowerLimit is a yyyy-MM-dd calendar date. It is parsed with an explicit format so it is read in the same
 * frame as the period dates — parsing it as an instant would shift the day for browsers west of UTC.
 */
export const isTrendAvailable = ({ period, periodStartDate, periodEndDate, lowerLimit }) => {
  if (period !== 'Custom') return true;
  if (!lowerLimit) return true;

  const start = parsePeriodDate(periodStartDate);
  const end = parsePeriodDate(periodEndDate);
  if (!start?.isValid() || !end?.isValid()) return true;

  const periodLength = end.diff(start, 'days') + 1;
  return !start
    .clone()
    .subtract(periodLength, 'days')
    .isBefore(moment(lowerLimit, DATE_FORMAT), 'day');
};
